export default "__VITE_ASSET__CLcBC7L6__"